<template>
  <div class='is-flex' :class='isMovil ? "is-justify-center" : "" '>
    <button
        class="button is-dark"
        v-on:click='sendEmails()'
    >
          Enviar informes a líderes
          <span class="icon" style='margin-left: 5px'>
            <i class="material-icons">send</i>
          </span>
    </button>
  </div>
</template>
<script>
import apiServices from '@/services/yungol-services'
import {mapState} from 'vuex'

export default {
  data(){
    return {

    }
  },
  props:{
    proceso: Object
  },
  computed:{
    ...mapState(['isMovil']),
  },
  methods:{
    async sendEmails(){
      const config = {
        title: '¿Estás seguro?',
        text: "Enviaras los correos a todos los líderes.",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#de5b5b',
        confirmButtonText: 'Sí, enviar'
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const resultD = await apiServices.get(
                `/crearusuariolideres/${this.proceso._id}`
            );
            if (resultD.data[0].error) {
              await this.$swal({
                text: resultD.data[0].error,
                icon: 'error',
                showConfirmButton: false,
                timer: 1700
              })
            } else {
              await this.$swal({
                text: 'Correos enviados correctamente.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1700
              })
            }
          } catch (error) {
            await this.$swal({
              text: 'Error al enviar los correos.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1700
            })
          }
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lideres/components/menuTableSummary.vue